module.exports = __webpack_public_path__ + "img/modal-image-mobile.866d042e.png";